import { addDays, endOfMonth, startOfDay, startOfMonth } from 'date-fns';

export const getCurrentWeekDates = () => {
  const today = new Date();
  const startDate = startOfDay(today);
  const endDate = startOfDay(addDays(today, 2));
  return { startDate, endDate };
};

export const getCurrentMonthDates = () => {
  const today = new Date();
  const startDate = startOfMonth(today);
  const endDate = endOfMonth(today);
  return { startDate, endDate };
};
